import store from '@/store';
import utils from '@/utils';
import constant from '~/const';

const defaultNavigation = [
  { title: 'ID', routeName: 'user-id' },

  { title: 'Security', routeName: 'user-security' },

  { title: 'Balance', routeName: 'user-balance' },


  { title: 'Trading', routeName: 'user-trading' },

  { title: 'P2P', routeName: 'user-p2p' },

  { title: 'API', routeName: 'user-api' },

  { title: 'Chats', routeName: 'user-chats' },

  { title: 'Notifications', routeName: 'user-notifications' },

  { title: 'Staking', routeName: 'user-staking' },


  { title: 'Merchant', routeName: 'user-merchant' },

];

const forTraderLeadsAndTraders = [
  { title: 'Referrals', routeName: 'user-referrals' },
];

const getNavigationUser = () => {
  const { user } = store.state.user;

  if (utils.getAppType() === 'p2pay') {
    if (user?.roles?.includes(constant.users.USER_ROLE.TRADER_LEAD) || user?.roles?.includes(constant.users.USER_ROLE.TRADER)) {
      return [...defaultNavigation, ...forTraderLeadsAndTraders];
    }
    return defaultNavigation;
  }

  return [...defaultNavigation, ...forTraderLeadsAndTraders];
};

export default getNavigationUser;
